const BackOrderRoutes = [
  {
    path: '/view-back-orders',
    name: 'view-back-orders',
    component: () => import('@/components/backOrders/ViewBackOrders.vue'),
  },
  //Backorders List
  {
    path: '/backorders',
    name: 'backorders',
    component: () => import('@/components/orders/backorders/BackOrders'),
  },

  //Aggregate Backorders List

  {
    path: '/aggregates-backorders',
    name: 'aggregates-backorders',
    component: () => import('@/components/orders/backorders/AggregatesOrder'),
  },
  //Back Orders Details
  {
    path: '/back-order-details',
    name: 'back-order-details',
    component: () => import('@/components/backOrders/BackOrdersDetails'),
  },
];

export default BackOrderRoutes;
